import { render, staticRenderFns } from "./FormSolicitacao.vue?vue&type=template&id=cb3ad072&"
import script from "./FormSolicitacao.vue?vue&type=script&lang=js&"
export * from "./FormSolicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports